import {  ErrorMessage, Form, Formik } from "formik";
import React  from "react";
import { Button, Col, Input, Label, Row } from "reactstrap";
import { StaticModalToggleProp } from "../../../../types/modal/ModalTypes";
import { Btn, H3, H5, Image } from "../../../../AbstractElements";
import { dynamicImage } from "../../../../service";
import { useTranslation } from "react-i18next";
import * as Yup from "yup";

const UserResetPassword: React.FC<StaticModalToggleProp> = ({ staticModalToggle,data }) => {

    const {t}= useTranslation()
    const validationSchema = Yup.object().shape({
      email: Yup.string()
        .email("Invalid email address")
        .required("Email is required"),
      password: Yup.string()
        .min(8, "Password must be at least 8 characters")
        .matches(
          /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{8,}$/,
          "Password must contain at least one uppercase letter, one lowercase letter, one number, and one special character"
        )
        .required("Password is required"),
      confirmPassword: Yup.string()
        .oneOf([Yup.ref("password")], "Passwords must match")
        .required("Confirm Password is required"),
    });
  return (
    <Formik
      initialValues={{ email: "", password: "" }}
      onSubmit={() => {
        // Handle form submission here if needed
      }}
      validationSchema={validationSchema}
    >
      {() => (
        <Form>
          <Row className="g-3" style={{paddingTop:"1rem"}}>
        
          <Row  id="addIcon">
            <div className="profile-mail">
              <div className="d-flex">
                <Image
                  className="img-100 img-fluid m-r-20 rounded-circle update_img_0"
                  src={dynamicImage(data?.image)}
                  alt="users"
                />
                
                <div className="social-details">
                  <H3 className="mb-1 d-flex align-items-center gap-2">
                    {data?.name}
                  </H3>
                  <H5 className="mb-1 d-flex align-items-center gap-2">
                    <i className="fa fa-phone" />
                   {data?.phonenumber}
                  </H5>
                  <H5 className="mb-1 d-flex align-items-center gap-2">
                    <i className="fa fa-envelope" />
                    <span className="f-light"> {data?.email}</span>
                  </H5>
                </div>
               
              </div>

            
            </div>
          </Row>
         
          <Col xs="12">
            
              <Label check>{t("password")} <span className="txt-danger">*</span></Label>
              <Input  name="password" type="password" placeholder={t("EnterPassword")} autoComplete='' />
              <ErrorMessage
                name="email"
                component="span"
                className="text-danger"
              />
          </Col>
          <Col xs="12">
           
              <Label check>{t("ConfirmPassword")} <span className="txt-danger">*</span></Label>
              <Input  name="confirmPassword" type="password" autoComplete='' placeholder={t("EnterConfirmPassword")} />
              <ErrorMessage
                name="password"
                component="span"
                className="text-danger"
              />
          </Col>
         
           
          <div className="text-end mt-3">
              <Button
                color="secondary"
                className="me-2"
                type="button"
                onClick={staticModalToggle}
              >
                {t("Cancel")}
              </Button>
              <Button color="primary" type="submit">
                {t("Save")}
              </Button>
            </div>
          </Row>
        </Form>
      )}
    </Formik>
  );
};

export default UserResetPassword;
